import styled from "styled-components";
import { Meta } from "@sablier/v2-components/organisms";
import { Page as PagePartial } from "~/client/components";
import { pages } from "~/client/constants";
import { CreateGroupFormProvider as Provider } from "~/client/contexts";
import Confirmation from "./Confirmation";
import Form from "./Form";
import Summary from "./Summary";
import Top from "./Top";

const Container = styled.div`
  ${(props) => props.theme.styles.contained}
  & {
    width: 100%;
  }
`;

const Main = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    align-items: flex-start;
    width: 100%;
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 2);
    column-gap: calc(${(props) => props.theme.sizes.edge} * 2);
  }
`;

const Checkout = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 2);
    width: ${(props) => props.theme.sizes.summary};
  }
`;

const Page = styled(PagePartial)`
  ${(props) => props.theme.medias.maxLG} {
    ${Main} {
      ${(props) => props.theme.styles.column}
      & {
        gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
        width: 100%;
        padding: 0;
        padding-bottom: calc(${(props) => props.theme.sizes.edge} * 2);
      }
    }
    ${Checkout} {
      ${(props) => props.theme.styles.contained}
      gap: calc(${(props) => props.theme.sizes.edge} * 3/2);
      width: 100%;
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    ${Container} {
      padding: 0;
      & > *:first-child {
        padding-left: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
      }
    }
  }
`;

function CreateGroup() {
  return (
    <Provider>
      <Meta.Head title={pages.createGroup.title} />
      <Page>
        <Container>
          <Top />
          <Main>
            <Form />
            <Checkout>
              <Summary />
              <Confirmation />
            </Checkout>
          </Main>
        </Container>
      </Page>
    </Provider>
  );
}

export default CreateGroup;
